var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateMenuInvestor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 55.4999L9 55.4999",
    stroke: "#585D66",
    strokeWidth: 1.0012,
    strokeLinejoin: "bevel"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.3242,
    y: 16.4999,
    width: 19,
    height: 39,
    stroke: "#585D66",
    strokeWidth: 1.0012,
    strokeLinejoin: "bevel"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.3242,
    y: 38.4999,
    width: 22,
    height: 17,
    stroke: "#585D66",
    strokeWidth: 1.0012,
    strokeLinejoin: "bevel"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23.0117,
    y: 48.8503,
    width: 3.40698,
    height: 3.40698,
    stroke: "#585D66",
    strokeWidth: 1.0012,
    strokeLinejoin: "bevel"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23.0117,
    y: 42.0364,
    width: 3.40698,
    height: 3.40698,
    stroke: "#585D66",
    strokeWidth: 1.0012,
    strokeLinejoin: "bevel"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 23.0117,
    y: 35.2224,
    width: 3.40698,
    height: 3.40698,
    stroke: "#585D66",
    strokeWidth: 1.0012,
    strokeLinejoin: "bevel"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 23.0117,
    y: 28.4084,
    width: 3.40698,
    height: 3.40698,
    stroke: "#585D66",
    strokeWidth: 1.0012,
    strokeLinejoin: "bevel"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 38.3438,
    y: 42.0364,
    width: 3.40698,
    height: 3.40698,
    stroke: "#585D66",
    strokeWidth: 1.0012,
    strokeLinejoin: "bevel"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 45.156,
    y: 42.0364,
    width: 3.40698,
    height: 3.40698,
    stroke: "#585D66",
    strokeWidth: 1.0012,
    strokeLinejoin: "bevel"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 38.3438,
    y: 48.8503,
    width: 3.40698,
    height: 3.40698,
    stroke: "#585D66",
    strokeWidth: 1.0012,
    strokeLinejoin: "bevel"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 45.156,
    y: 48.8503,
    width: 3.40698,
    height: 3.40698,
    stroke: "#585D66",
    strokeWidth: 1.0012,
    strokeLinejoin: "bevel"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateMenuInvestor);
export default __webpack_public_path__ + "static/media/create-menu-investor.28d623e5c19a1e9c9d21059387fab0c2.svg";
export { ForwardRef as ReactComponent };